import React from 'react'
import AdminSidebar from '../components/AdminSidebar'
import PolicyBody from '../../components/PolicyBody'
import PrivacyContent from '../../components/PrivacyContent'

/**
 * 관리자용 개인정보처리방침 (보기 전용)
 *
 * 사용자 화면과 같은 것을 보여준다 — 서버(policies 표)의 내용이다.
 * **고치는 곳은 /admin/policies 다.** 여기는 결과를 확인하는 자리다.
 *
 * 예전에는 여기만 PrivacyContent(코드본)를 보고 있어서, 서버에서 방침을
 * 고쳐도 이 화면은 옛 내용을 보여줬다. 실제로 7월 23일에 서버에서 고친 내용이
 * 앱에 반영되지 않은 채였다.
 */
const AdminPrivacyPolicy: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-backgroundColorBg2">
      <AdminSidebar />
      <div className="flex-1 flex flex-col">
        <div className="bg-white border-b border-brandPrimary-10% p-24px">
          <h1 className="font-pretendard font-bold text-24px text-textColorText2">
            개인정보처리방침
          </h1>
        </div>
        <div className="flex-1 overflow-y-auto scrollbar-hide p-24px">
          <div className="max-w-4xl bg-white rounded-8px p-24px">
            <PolicyBody policyKey="privacy" fallback={<PrivacyContent />} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminPrivacyPolicy
